import { field, scope, vector } from '../instructions';
import { MetaZoneIndex, TimeZoneTypeIndex } from '../schema/timezones';
export var TIMEZONE = scope('TimeZoneNames', 'TimeZones', [
    scope('metaZones', 'metaZones', [
        vector('short', ['timezone-type', 'metazone']),
        vector('long', ['timezone-type', 'metazone']),
    ]),
    vector('exemplarCity', ['timezone-id']),
    field('gmtFormat'),
    field('hourFormat'),
    field('gmtZeroFormat'),
    field('regionFormat'),
]);
export var TIMEZONE_INDICES = {
    metazone: MetaZoneIndex,
    'timezone-type': TimeZoneTypeIndex,
};
//# sourceMappingURL=timezones.js.map